import React from "react";
import { InputLabel } from "@mui/material";

const DSInputLabel = (props: React.ComponentProps<typeof InputLabel>) => {
  return <InputLabel {...props} />;
};

export default DSInputLabel;
